import React, { useState, useEffect } from "react";
import { Box, Flex, IconButton, useColorModeValue } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { BsList } from "react-icons/bs";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import StickyNavbar from "./StickyNavbar";

const STORAGE_KEY = "sidebar:collapsed";

const AdminPanel = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const fabBg = useColorModeValue("teal.500", "teal.600");
  const fabHoverBg = useColorModeValue("teal.600", "teal.700");

  // helper to read localStorage
  const readCollapsed = () => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) === true : false;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    // initial read
    setCollapsed(readCollapsed());

    // handle changes (both same tab + other tabs)
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY && e.newValue != null) {
        try {
          setCollapsed(JSON.parse(e.newValue));
        } catch {}
      }
    };

    window.addEventListener("storage", onStorage);

    // custom event for same-tab updates
    const onCustom = () => setCollapsed(readCollapsed());
    window.addEventListener("sidebar-toggle", onCustom);

    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("sidebar-toggle", onCustom);
    };
  }, []);

  const sidebarWidth = collapsed ? 64 : 240;

  return (
    <>
      <StickyNavbar />

      <Flex position="relative" minH="calc(100dvh - 56px)" w="full" align="stretch">
        <Sidebar />
        <Box
          ml={{ base: 0, md: `${sidebarWidth}px` }}
          minH="calc(100dvh - 56px)"
          width={{ base: "100%", md: `calc(100% - ${sidebarWidth}px)` }}
          overflowX="hidden"
          mt="0"
          pt="0"
        >
          <Outlet />
        </Box>

        <IconButton
          icon={<BsList />}
          aria-label="Open menu"
          onClick={() => navigate("/")}
          position="fixed"
          bottom={{ base: 6, md: 8 }}
          right={{ base: 6, md: 8 }}
          borderRadius="full"
          bg={fabBg}
          color="white"
          boxSize={{ base: 14, md: 16 }}
          fontSize={{ base: "lg", md: "xl" }}
          _hover={{ bg: fabHoverBg, transform: "scale(1.1)" }}
          _active={{ transform: "scale(0.95)" }}
          transition="all 0.2s ease"
          boxShadow="lg"
          display={{ base: "flex", md: "none" }}
        />
      </Flex>
    </>
  );
};

export default AdminPanel;
